import { isEndUserAccountConnected } from 'services/endUser/endUserRouteAccess';
import {
  resolveEndUserJourneyRoute,
  type EndUserJourneyRouteReason,
} from 'services/endUser/resolveEndUserJourneyRoute';

const ONBOARDING_CONNECTED_REDIRECT_REASONS = new Set<EndUserJourneyRouteReason>([
  'end-user-home',
  'full-flow',
]);

/**
 * During FTUE Find Expenses only: already-connected users skip Connect health insurance
 * and follow the same Home / Expenses journey as DashboardResolver.
 * Dashboard / My Account / no-expense re-entry must keep Find Expenses reachable.
 */
export function resolveOnboardingFindExpensesConnectedRedirect(params: {
  accountState: string | null;
  profileState: string | null;
  hasExpenses: boolean;
  isIntentionalFindExpensesReentry: boolean;
}): string | null {
  if (params.isIntentionalFindExpensesReentry) {
    return null;
  }

  if (!isEndUserAccountConnected(params.accountState)) {
    return null;
  }

  const destination = resolveEndUserJourneyRoute({
    state: params.profileState,
    accountState: params.accountState,
    hasExpenses: params.hasExpenses,
  });

  if (!ONBOARDING_CONNECTED_REDIRECT_REASONS.has(destination.reason)) {
    return null;
  }

  return destination.path;
}
